var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[_vm._t("content")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63c487ba","hasScoped":false,"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/sharedcomponents/GenericList.vue
// module id = null
// module chunks = 